import { container } from "assets/jss/material-kit-react.js";

const componentsStyle = {
  container,
  brand: {
    color: "#FFFFFF",
    textAlign: "left",
  },
  title: {
    fontWeight: "600",
    display: "inline-block",
    position: "relative",
  },
  subtitle: {
    margin: "10px 0 0",
  },
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3",
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
  },
  link: {
    textDecoration: "none",
  },
  textCenter: {
    textAlign: "center",
  },
  mainContainer: {
    padding: "50px 100px 50px",
  },

  mainContainer2: {
    padding: "0px 100px 50px",
  },
  customButton: {
    marginTop: "10px",
    borderColor: "white",
    color: "white",
    "&:hover": {
      backgroundColor: "white",
      color: "black",
    },
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "center",
    "&:last-child": {
      borderRight: "none",
    },
    borderRight: "1px solid grey",
  },
  text: {
    marginTop: 10,
    color: "black",
  },
};

export default componentsStyle;
